// Item library evaluate codes for /roads-sewers/storm-sewers Box Culverts
// build-up dev-mode display — mirrors prelimsMapping.ts's description -> code
// lookup pattern.
//
// A few rows embed a live-configured value in their description instead of
// fixed text (concrete blinding thickness, pipe bedding thickness, backfill
// type, purchase FP % — see stormBuildUpBoxCulverts.ts's
// BOX_CULVERT_CONFIGURABLE_FIELDS) — those are matched by pattern rather than
// exact text so the code still resolves whatever value is currently
// configured (or the "xxx" placeholder before it's configured). Backfill
// resolves to the same code regardless of which dropdown type is selected —
// only one code was given for that row.
//
// The "Culvert N" header, the "<size>mm Box Culvert - <depth>m dp" sub-header,
// and the "Height" row have no code and are intentionally left out of the map.

export interface StormBoxCulvertsEvaluateCodeItem {
  description: string;
  code: string;
}

const NUM = '\\d+(?:\\.\\d+)?|xxx';

export const BOX_CULVERTS_EVALUATE_CODES: StormBoxCulvertsEvaluateCodeItem[] = [
  { description: 'Excavate', code: 'ALP010' },
  { description: 'Earthwork support', code: 'ALP020A' },
  { description: 'Compact Base of Trench', code: 'ALP030' },
  { description: 'Deposit on site', code: 'ALP040' },
  { description: 'Labour & Plant - Install culverts', code: 'ACL004' },
];

const PATTERNS: { pattern: RegExp; code: string }[] = [
  { pattern: new RegExp(`^Concrete blinding (${NUM})mm thick$`), code: 'GWALP013a' },
  { pattern: new RegExp(`^Pipe bedding (${NUM})mm thick top & bottom$`), code: 'ALP050' },
  { pattern: new RegExp(`^Pipe bedding (${NUM})mm thick sides$`), code: 'ALP050' },
  { pattern: /^Backfill \(.+ Under Carriageway\)$/, code: 'ALP017c' },
  { pattern: new RegExp(`^Purchase price of culvert incl (${NUM})% FP$`), code: 'APM6000' },
];

export function findBoxCulvertsEvaluateCode(description: string): string | undefined {
  const fixed = BOX_CULVERTS_EVALUATE_CODES.find((i) => i.description === description)?.code;
  if (fixed) return fixed;
  return PATTERNS.find((p) => p.pattern.test(description))?.code;
}
